import { useEffect } from 'react';
import { ReleaseDetails } from '@frontend/wam-views';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { useS3 } from '../../hooks/useS3';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  const { releaseId } = Route.useParams() as { releaseId: string };
  const { s3State, loading, handleDownload, deleteFile, loadVersionAssets } = useS3({
    prefix: 'weave-updates/',
  });

  useEffect(() => {
    loadVersionAssets(releaseId);
  }, [loadVersionAssets, releaseId]);

  return (
    <Page
      title={`Release: ${releaseId}`}
      breadcrumbs={[
        {
          label: 'Global Settings',
          to: '/global-settings',
        },
        {
          label: 'Desktop Releases',
          to: '/global-settings/desktop-releases',
        },
        {
          label: releaseId,
        },
      ]}
    >
      <Container>
        <ReleaseDetails
          loading={loading}
          version={releaseId}
          versions={s3State.versionAssets}
          deleteFile={deleteFile}
          handleDownload={handleDownload}
        />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/desktop-releases_/$releaseId',
  type: 'auth',
  component: RouteComponent,
});
